import video from '../img/video.mp4'

function Main() {
    return(
      <div className='video-wrapper'>
        <video autoPlay loop muted>
            <source src={video} type='video/mp4' />
        </video>
      </div>
    );
}

export default Main;
